import { useEffect, useState } from "react";
import { Menu } from "../../components/menu/menu";
import { Story, StoryPositin } from "../../components/story/story";
import { bemCN } from "../../config/bem-classname";
import { Story as StoryClass } from "../../view-models/story";
import "./stories-page.scss";
import { storyService } from "../../services/story-service";
import { Modal } from "../../ui/modal/modal";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { ReactComponent as PlayIcon } from "../../shared/images/svg/play.svg";
import { ReactComponent as CrossIcon } from "../../shared/images/svg/cross.svg";
import { links } from "../../config/links";
import { useLocation, useNavigate } from "react-router";
import { BeforeInstallPromptEvent } from "../../models/beforeinstallevent";
import { useSelector } from "react-redux";
import { RootState, typedDispatch } from "../../store";
import { setEventDownload } from "../../store/download-android/action";
const storiesPageCn = bemCN("stories-page");

export const StoriesPage = () => {
  const [activeId, setActiveId] = useState(-1);
  const [stories, setStories] = useState<StoryClass[]>();
  const navigate = useNavigate();

  const [isShowModalIOS, setIsShowModalIOS] = useState(false);

  useEffect(() => {
    const detectOS = () =>
      /android/i.test(navigator.userAgent)
        ? "Android"
        : /iPad|iPhone|iPod/.test(navigator.userAgent)
          ? "iOS"
          : "Неустановленная ОС";
    if (detectOS() == "iOS") {
      if (!window.matchMedia("(display-mode: standalone)").matches) {
        // console.log("В браузере");
        setIsShowModalIOS(true);
      }
    }
  }, [1]);

  const onClickStory = (id: number) => {
    setActiveId(id);
  };

  const getStories = () => {
    storyService.getStories().then((res: StoryClass[]) => {
      setStories(res);
    });
  };

  useEffect(() => {
    getStories();
  }, [1]);

  // const [installEvent, setInstallEvent] =
  //   useState<BeforeInstallPromptEvent | null>(null);

  const installEvent: BeforeInstallPromptEvent = useSelector(
    (state: RootState) => state.androidDownloadReducer
  )?.event;
  const [isShowModal, setIsShowModal] = useState(false);
  const location = useLocation();
  useEffect(() => {
    window.addEventListener("beforeinstallprompt", async (event: any) => {
      if (event) {
        event.preventDefault();
        typedDispatch(setEventDownload(event));
        // setInstallEvent(event);
        // let btn = document.getElementById("dwnldBtn");
        // if (btn) {
        //   btn.addEventListener("click", async () => {
        //     const result = await event.prompt();
        //     localStorageService.setValue(
        //       LocalStorageVariableName.isShowDownloadModal,
        //       false
        //     );
        //     setIsShowModal(false);
        //   });
        // }
        // localStorageService.setValue(
        //   LocalStorageVariableName.isShowDownloadModal,
        //   true
        // );

        // if (window.location.href.includes("stories")) {
        //   setIsShowModal(true);
        // }
        // setIsShowModal(true);
      }
    });
  }, [1]);

  useEffect(() => {
    if (
      installEvent !=undefined &&
      location.pathname.includes("stories")
    ) {
      setIsShowModal(true);
    }
  }, [location]);
  return (
    <div className={storiesPageCn()}>
      <Menu title="Книги" />
      <div className={storiesPageCn("stories")}>
        {stories &&
          stories.map((story: StoryClass, index: number) => (
            <Story
              key={story.id}
              story={story}
              position={index % 2 == 0 ? StoryPositin.left : StoryPositin.right}
              isActive={activeId == story.id ? true : false}
              onClickStory={onClickStory}
            />
          ))}
      </div>
      <Modal
        id="iOSModal"
        isShowDialog={isShowModalIOS}
        setIsShowDialog={setIsShowModalIOS}
      >
        <div>
          <Button
            icon={<CrossIcon />}
            color={ButtonColors.transition}
            size={ButtonSizes.small}
            onClick={() => setIsShowModalIOS(false)}
          />
          <Button
            icon={<PlayIcon />}
            color={ButtonColors.transition}
            size={ButtonSizes.small}
            onClick={() => {
              setIsShowModalIOS(false);
              navigate(links.instruction);
            }}
          />
          <p>Как установить приложение</p>
        </div>
      </Modal>
      <Modal
        id="saveAppMobile"
        isShowDialog={isShowModal}
        setIsShowDialog={setIsShowModal}
      >
        <div className="download_modal">
          <Button
            onClick={() => {
              setIsShowModal(false);
            }}
            icon={<CrossIcon />}
            color={ButtonColors.transition}
            size={ButtonSizes.small}
          />
          <p>Вы можете установить приложение на свое устройство!</p>
          <Button
            id="dwnldBtn"
            text="Установить"
            size={ButtonSizes.big}
            color={ButtonColors.green}
            onClick={async () => {
              console.log(installEvent);
              if (installEvent) {
                const result = await installEvent.prompt();
                // localStorageService.setValue(
                //   LocalStorageVariableName.isShowDownloadModal,
                //   false
                // );
                setIsShowModal(false);
              }
            }}
          />
        </div>
      </Modal>
    </div>
  );
};
